import React from 'react';

import Header from '../../components/Header';

import './index.css';

const headerTitle = 'Uh oh';
const headerDescription = 'We have to get back to the pizza! Let’s get you to the homepage.';

const NotFoundPage: React.FC = () => {
    return (
        <div className="index-container">
            <div className="index-form-wrapper">
                <Header title={headerTitle} description={headerDescription} />
                <a className="not-found-anchor-wrapper" href="https://slicelife.com">
                    <button className="not-found-button">Return to Slice</button>
                </a>
            </div>
        </div>
    );
};

export default NotFoundPage;
